// import React from "react";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import { useNavigate, useParams,useLocation } from "react-router-dom";
// import { useGetFarmerByIdQuery } from "./farmerApiSlice";
// import { useEffect, useState } from "react";
// import FarmerDetailsBasic from "./FarmerDetailsBasic";
// import FarmerDetailsBank from "./FarmerDetailsBank";
// import FarmerDetailsFamily from "./FarmerDetailsFamily";
// import FarmerDetailsLiability from "./farmerDetailsLiability";
// import FarmerDetailsAssets from "./FarmerDetailsAssets";
// import FarmerDetailsLand from "./FarmerDetailsLand";
// import FarmerDetailsResidential from "./FarmerDetailsResidential";
// import FarmerDocuments from "./FarmerDocuments";
// import { setBreadcrumbs } from "app/appSlice";
// import { useDispatch } from "react-redux";
// import SummaryFarmerOnboarding from "./SummaryFarmerOnboarding";
// import FarmerDetailsCattle from "./FarmerDetailsCattle";
// import { useSelector } from "react-redux";
// import { selectCurrentUser } from "features/auth/authSlice";
// import HclDashNav from "components/HclDashNav";
// import { TabPanel } from "features/Procurement/common/TabPanel";
// import GovernNav from "components/Government/GovernNav";
// import ProjectNavbar from "features/dashboard/Project/ProjectNavbar";

// const FarmerDetails = () => {
//   const { id } = useParams();
//   const Navigate = useNavigate();
//    const location = useLocation();
//       console.log("location",location)
//       const noSidebar = location.pathname.includes("farmerDetail");
//   const currentUser = useSelector(selectCurrentUser);
//   const RoleAcessParams = currentUser?.realm_access?.roles;
//   const { data, isLoading, isFetching, refetch } = useGetFarmerByIdQuery(id, {
//     refetchOnMountOrArgChange: "always",
//     keepUnusedDataFor: 0,
//   });

//   const pathName = window.location.pathname.split("/");
//   const moduleName = pathName[pathName.length - 1];
//   const moduleNameFromgPath =
//     moduleName.charAt(0).toUpperCase() + moduleName.slice(1);

//   const dispatch = useDispatch();
//   useEffect(() => {
//     const breadcrumbs = [
//       { name: "Dashboard", link: "/dashboard" },
//       { name: "Farmers", link: "/onboarding/farmers" },
//       { name: "Detail View" },
//     ];
//     dispatch(setBreadcrumbs(breadcrumbs));
//   }, []);
//   const [value, setValue] = useState(0);
//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };
//   const handleActiveCard = (cardName) => {
//     Navigate(cardName);
//   };
//   useEffect(() => {
//     refetch();
//   }, [id, refetch]);
//   return (
//     <div
//       className="p-lg-0 p-md-0 p-2"
//       style={{ padding: RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar? "30px" : "" }}
//     >
//       {RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar ? (
//         ""
//       ) : (
//         <div
//           className="radio-inputs d-flex justify-content-between flex-wrap"
//           style={{ width: "100%" }}
//         >
//           <label className="radio">
//             <div onClick={() => handleActiveCard("")}>
//               <input type="radio" name="radio" defaultChecked />
//               <h4 className="name2 text-primary m-0">Basic Detail</h4>
//             </div>
//           </label>
//           <label className="radio">
//             <div onClick={() => handleActiveCard("loanapplication")}>
//               <input type="radio" name="radio" />
//               <h4 className="name2 m-0">Loan Applications</h4>
//             </div>
//           </label>
//         </div>
//       )}
//       {RoleAcessParams.includes("HCL") ? <HclDashNav />: ""}
//       {RoleAcessParams.includes("HCL") ? <HclDashNav /> : RoleAcessParams.includes("UP_GOV")?<GovernNav/>: noSidebar?<ProjectNavbar/>: ""}

//       <div
//         className={RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar ? "container-fluid" : ""}
//         style={{
//           paddingLeft: RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar ? "6rem" : "",
//           paddingRight: RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar ? "6rem" : "",
//         }}
//       >
//         <div
//           className="p-1 p-lg-3 transparent_card "
//           style={{
//             padding: RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV") || noSidebar ? "10px" : "",
//           }}
//         >
//           <div className="d-flex justify-content-between mt-1 right-border-shadow">
//             <div
//               className="tabs-container"
//               style={{ overflowX: "auto", whiteSpace: "nowrap" }}
//             >
//               <Tabs
//                 value={value}
//                 onChange={handleChange}
//                 indicatorColor="primary"
//                 variant="scrollable"
//               >
//                 <Tab label="Summary" className="f14" />
//                 <Tab label="Personal" className="f14" />
//                 <Tab label="Bank" className="f14" />
//                 <Tab label="Family" className="f14" />
//                 <Tab label="Liability" className="f14" />
//                 <Tab label="Assets" className="f14" />
//                 <Tab label="Cattle" className="f14" />

//                 <Tab label="Farm" className="f14" />
//                 <Tab label="Documents" className="f14" />
//               </Tabs>
//             </div>
//           </div>
//           <TabPanel value={value} index={0}>
//             <div className="mt-2">
//               <SummaryFarmerOnboarding
//                 data={data}
//                 refetch={refetch}
//                 isLoading={isLoading}
//                 applicationTabValue="0"
//                 RoleAcessParams={RoleAcessParams}
//               />
//             </div>
//           </TabPanel>
//           <TabPanel value={value} index={1}>
//             <FarmerDetailsBasic
//               data={data}
//               refetch={refetch}
//               isLoading={isLoading}
//             />
//             <div className="mt-2">
//               <FarmerDetailsResidential />
//             </div>
//           </TabPanel>

//           <TabPanel value={value} index={2}>
//             <FarmerDetailsBank tabIndex={value} />
//           </TabPanel>
//           <TabPanel value={value} index={3}>
//             <FarmerDetailsFamily />
//           </TabPanel>
//           <TabPanel value={value} index={4}>
//             <FarmerDetailsLiability />
//           </TabPanel>
//           <TabPanel value={value} index={5}>
//             <FarmerDetailsAssets />
//           </TabPanel>
//           <TabPanel value={value} index={6}>
//             <FarmerDetailsCattle DocData={data} />
//           </TabPanel>
//           <TabPanel value={value} index={7}>
//             <FarmerDetailsLand
//               tabIndex={value}
//               data={data}
//               refetch={refetch}
//               isLoading={isLoading}
//               RoleAcessParams={RoleAcessParams}
//             />
//           </TabPanel>
//           <TabPanel value={value} index={8}>
//             <FarmerDocuments tabIndex={value} data={data} refetch={refetch} />
//           </TabPanel>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FarmerDetails;

import React, { useEffect, useState, } from "react";
import { useParams, useLocation } from "react-router-dom";
// import { useGetFarmerByIdQuery } from "./farmerApiSlice";
import { setBreadcrumbs } from "app/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import HclDashNav from "components/HclDashNav";
import GovernNav from "components/Government/GovernNav";
import ProjectNavbar from "features/dashboard/Project/ProjectNavbar";
import SummaryFarmerOnboarding from "./SummaryFarmerOnboarding";
import FarmerDetailsBasic from "./FarmerDetailsBasic";
import FarmerDetailsBank from "./FarmerDetailsBank";
import FarmerDetailsFamily from "./FarmerDetailsFamily";
import FarmerDetailsLiability from "./farmerDetailsLiability";
import FarmerDetailsAssets from "./FarmerDetailsAssets";
import FarmerDetailsLand from "./FarmerDetailsLand";
import FarmerDetailsResidential from "./FarmerDetailsResidential";
import FarmerDocuments from "./FarmerDocuments";
import FarmerDetailsCattle from "./FarmerDetailsCattle";
import axios from "axios";
import { API_URL } from "app/config";
import { store } from "app/store";

const FarmerDetails = () => {
  const { id } = useParams();

  const location = useLocation();
  const activeTab = location.state?.active || "Summary";
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const noSidebar = location.pathname.includes("farmerDetail");
  //   const { data: farmerData, isLoading,refetch, } = useGetFarmerByIdQuery(id, {
  //   refetchOnMountOrArgChange: true,
  //   keepUnusedDataFor: 0,
  //   forceRefetch: true,
  // });

  const [farmerData, setFarmerData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [activeSection, setActiveSection] = useState(activeTab);
  const cards = [
    {
      key: "Summary",
      label: "Summary",
      value: "-",
      icon: "mdi-chart-box",
      bg: "#c3aed6",
    },
    {
      key: "Personal",
      label: "Personal",
      value: "-",
      icon: "mdi-account",
      bg: "#9ad0ec",
    },
    {
      key: "Bank",
      label: "Bank Accounts",
      icon: "mdi-bank",
      bg: "#7adbe8",
    },
    {
      key: "Family",
      label: "Family Members",
      icon: "mdi-account-group",
      bg: "#f1769a",
    },
    {
      key: "Liability",
      label: "Liabilities",
      icon: "mdi-cash-minus",
      bg: "#6fe67d",
    },
    {
      key: "Assets",
      label: "Assets",
      icon: "mdi-cube-outline",
      bg: "#e4ac64",
    },
    {
      key: "Cattle",
      label: "Cattle",
      icon: "mdi-cow",
      bg: "#f7a76c",
    },
    {
      key: "Farm",
      label: "Farms",
      icon: "mdi-land-fields",
      bg: "#dc70eb",
    },
    {
      key: "Documents",
      label: "Documents",
      icon: "mdi-file-image",
      bg: "#f7a76c",
    },
  ];

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { name: "Dashboard", link: "/dashboard" },
        { name: "Farmers", link: "/onboarding/farmers" },
        { name: "Detail View" },
      ])
    );
  }, []);

  const refetch = async () => {
    const state = store.getState();
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/api/v1/onboarding/farmers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFarmerData(response.data);
      setIsLoading(false)
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };
  useEffect(() => {
    refetch();
  }, []);

  // useEffect(() => {
  //   refetch();
  // }, [id, refetch]);
  console.log("first id",id)
  const renderSection = () => {
    switch (activeSection) {
      case "Summary":
        return (
          <SummaryFarmerOnboarding
            data={farmerData}
            refetch={refetch}
            isLoading={isLoading}
            applicationTabValue="0"
            RoleAcessParams={RoleAcessParams}
            id={id}
          />
        );
      case "Personal":
        return (
          <>
            <FarmerDetailsBasic
              data={farmerData}
              refetch={refetch}
              isLoading={isLoading}
            />
            <FarmerDetailsResidential />
          </>
        );
      case "Bank":
        return <FarmerDetailsBank tabIndex={activeSection} />;
      case "Family":
        return <FarmerDetailsFamily />;
      case "Liability":
        return <FarmerDetailsLiability />;
      case "Assets":
        return <FarmerDetailsAssets />;
      case "Cattle":
        return <FarmerDetailsCattle DocData={farmerData} />;
      case "Farm":
        return (
          <FarmerDetailsLand
            tabIndex={activeSection}
            data={farmerData}
            refetch={refetch}
            isLoading={isLoading}
            RoleAcessParams={RoleAcessParams}
          />
        );
      case "Documents":
        return (
          <FarmerDocuments
            tabIndex={activeSection}
            data={farmerData}
            refetch={refetch}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="p-lg-0 p-md-0 p-2"
      style={{
        padding:
          RoleAcessParams.includes("HCL") ||
          RoleAcessParams.includes("UP_GOV") ||
          noSidebar
            ? "30px"
            : "",
      }}
    >
      {RoleAcessParams.includes("HCL") ? (
        <HclDashNav />
      ) : RoleAcessParams.includes("UP_GOV") ? (
        <GovernNav />
      ) : noSidebar ? (
        <ProjectNavbar />
      ) : (
        ""
      )}
      <div
        className={
          RoleAcessParams.includes("HCL") ||
          RoleAcessParams.includes("UP_GOV") ||
          noSidebar
            ? "container-fluid"
            : ""
        }
        style={{
          paddingLeft:
            RoleAcessParams.includes("HCL") ||
            RoleAcessParams.includes("UP_GOV") ||
            noSidebar
              ? "6rem"
              : "",
          paddingRight:
            RoleAcessParams.includes("HCL") ||
            RoleAcessParams.includes("UP_GOV") ||
            noSidebar
              ? "6rem"
              : "",
        }}
      >
        <div className="p-1 p-lg-1 transparent_card mt-2">
          <div
            className="d-flex flex-nowrap overflow-auto gap-3 mb-1 pb-1"
            style={{ justifyContent: "flex-start" }}
          >
            {cards.map((item, index) => (
              <div
                key={index}
                className={`card flex-shrink-0 cursor-pointer ${
                  activeSection === item.key ? "shadow" : ""
                }`}
                style={{
                  width: "133px",
                  borderRadius: "0.75rem",
                  transition: "transform 0.2s",
                  cursor: "pointer",
                  border:
                    activeSection === item.key ? "1px solid orange" : "none",
                  borderTop:
                    activeSection === item.key
                      ? "1px solid orange"
                      : `1px solid ${item.bg}`,
                }}
                onClick={() => setActiveSection(item.key)}
              >
                <div className="card-body d-flex flex-column align-items-center p-1 mb-2">
                  <div className="mb-1" style={{ color: item.bg }}>
                    <i
                      className={`mdi ${item.icon}`}
                      style={{ fontSize: "1.4rem" }}
                    ></i>
                  </div>
                  <div
                    className="text-center mb-1 text-dark"
                    style={{ fontSize: "0.85rem" }}
                  >
                    {item.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="">{renderSection()}</div>
        </div>
      </div>
    </div>
  );
};

export default FarmerDetails;
